var _style, _defs, _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPortugal = function SvgPortugal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Portugal_svg__E{fill:#fee900}.Portugal_svg__F{fill:#641611}.Portugal_svg__G{fill:#fff}.Portugal_svg__H{fill:#3454a5}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Portugal_svg__C",
    d: "m69 84-1 1h1c1 1 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Portugal_svg__D",
    d: "M73 101h-1l1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Portugal_svg__E",
    d: "M83 101h-1l1 1h1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Portugal_svg__F",
    d: "M48 71h1zm3 1q0-1.5 0 0m-5 0q0-1.5 0 0"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "Portugal_svg__A"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99.6,
    cy: 99.6,
    r: 97.8,
    fill: "none",
    transform: "rotate(315 100 100)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Portugal_svg__B"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320.1,
    cy: 100,
    r: 98.1,
    fill: "none",
    transform: "rotate(279 320 100)"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.6,
    cy: 99.6,
    r: 97.8,
    fill: "none",
    stroke: "#a5a7aa",
    strokeWidth: 1.8,
    transform: "rotate(315 100 100)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Portugal_svg__A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ee2924",
    d: "M-47 197h294V2H-47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e8140",
    d: "M-47 197H71V2H-47z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Portugal_svg__E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 102c9 5 30 8 49 8 17 0 40-3 48-7v-5c-3 4-27 8-49 8-21 0-41-4-48-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 102v1a194 194 0 0 1-98 0v-1l20 5a189 189 0 0 0 78-5m0-4v1c-2 1-10 4-20 5a196 196 0 0 1-78-5v-2c4 3 16 5 20 6a189 189 0 0 0 78-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 102v1a194 194 0 0 1-98 0v-1l20 5a189 189 0 0 0 78-5m0-4v1c-2 1-10 4-20 5a196 196 0 0 1-78-5v-2c4 3 16 5 20 6a189 189 0 0 0 78-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 130c-15 0-82-43-83-50l4-6c6 10 76 51 83 50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 73c-1 4 18 16 40 30 23 14 43 22 44 21l1-1h-2c-6-2-22-9-42-21a186 186 0 0 1-40-30zm80 57h-1c-6 0-23-8-42-20-23-14-43-26-40-30v-1c-2 6 38 28 40 30 23 14 42 22 44 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 129c-21 0-39-6-43-7l3 5c6 3 24 7 40 6 16 0 30-1 39-6l3-5c-6 3-29 7-42 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111 126-1 2a114 114 0 0 1-39 6c-19 0-34-4-41-7l-1-1h1a135 135 0 0 0 65 5c10-2 15-4 16-5m3-4-1 1-19 5-23 2c-24-1-40-6-43-7l-1-1c14 4 28 6 44 6l23-1 19-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111 126-1 2a114 114 0 0 1-39 6c-19 0-34-4-41-7l-1-1h1a132 132 0 0 0 81 0m3-4-1 1-19 5-23 2c-24-1-40-6-43-7l-1-1c14 4 28 6 44 6l23-1 19-5zm0-44-2-3-14 3v4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113 75-1-1-14 4v1zm1 2c-1 1-6 3-16 5v1l17-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 51a49 49 0 0 0 0 97 49 49 0 0 0 0-97m0 92c-24 0-44-20-44-43s20-44 44-44 22 5 30 12a44 44 0 0 1-30 75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 52c-26 0-48 22-48 48s22 47 48 47 47-21 47-47-21-48-47-48m0 92c-25 0-45-20-45-44s20-45 45-45 23 5 31 13 13 19 13 31c0 25-20 45-44 45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 51h-4v98h1v-1h3v1h1V51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 67c18 0 33 2 40 6l3 5c-6-4-23-7-43-7-17 0-35 2-44 7l3-5c8-4 25-6 41-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 71c10 0 20 0 28 2l15 4 1 1-16-4c-8-2-18-2-28-2-12 0-21 0-29 2-8 1-13 3-15 5l1-2 14-4c8-2 17-2 29-2m0-5 27 2c6 2 12 3 14 5l1 2c-2-2-9-4-16-6a174 174 0 0 0-54 1c-7 1-11 2-13 4l1-2 12-3c8-2 17-2 28-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 73c15-1 84 42 84 49l-4 7c-2-9-72-50-83-50l3-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 79c3-2 23 7 44 20s42 28 40 30l-1 1v-1c-1-3-15-14-39-29-23-14-43-22-45-20zm88 44c2-4-17-18-40-32-24-13-41-21-44-19l-1 2v-1h2c6 0 21 7 43 19 9 6 40 26 40 31l-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 98c6-6 29-10 48-10 20 1 44 5 49 10v4c-4-4-23-9-49-9s-44 5-48 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 92c11 0 22 1 31 3s16 4 18 7v1c-3-3-12-6-18-7a169 169 0 0 0-63 0c-7 1-16 4-18 7v-1c1-2 8-5 18-7 8-2 19-3 31-3zm0-4c11 0 22 1 31 3s16 4 18 6v2c-3-4-12-6-18-7a168 168 0 0 0-63 0c-7 1-16 4-17 7v-2c0-1 7-4 17-6 8-2 20-3 32-3m24 32c-9-2-18-2-24-2-30 0-40 6-41 8l-3-4c8-5 24-8 44-8l26 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71 117 24 2-1 1c-7-1-15-2-23-1-12 0-23 0-32 3-4 1-9 3-9 5l-1-1c0-1 3-3 9-5 11-3 22-3 33-3zm0-4c9 0 18 1 26 3v1a123 123 0 0 0-59 2c-4 0-10 2-10 4l-1-1 10-5c11-3 23-4 34-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42 105c0 8 3 15 8 20a29 29 0 0 0 50-20V66H42z",
    className: "Portugal_svg__G"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee2924",
    d: "M71 133a28 28 0 0 1-28-28V67l55 1v37c0 7-3 14-8 20-5 5-12 8-19 8m-17-28a17 17 0 0 0 33 2V79H54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 68h55v37a27 27 0 0 1-27 28 28 28 0 0 1-28-28zm28 54c4 0 8-2 12-5 2-3 4-6 4-10V79H54v26c0 5 1 9 5 12 3 3 7 5 12 5M43 68v37a28 28 0 0 0 47 20c5-5 9-12 9-20V67H43Zm28 54a17 17 0 0 1-17-17V79h33v28c0 4-2 7-5 10s-7 5-12 5z",
    className: "Portugal_svg__F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67 88 1 3 3 1 2-1 1-3v-5h-7z",
    className: "Portugal_svg__H"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Portugal_svg__G"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#Portugal_svg__C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73 84-1 1h1c1 1 0 0 0 0zm-2 2-1 1h1zm2 2-1 1h1c1 1 0 0 0 0zm-4 0-1 1h1c1 1 0 0 0 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m67 101 1 3 3 1 2-1 1-3v-6h-7z",
    className: "Portugal_svg__H"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Portugal_svg__G"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#Portugal_svg__D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 101h-1l1 1zm2-2h-1l1 1zc1-1 0 0 0 0m2-2h-1l1 1zm-4 0h-1l1 1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m77 101 1 3 3 1 2-1 2-3v-6h-8z",
    className: "Portugal_svg__H"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Portugal_svg__G"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#Portugal_svg__E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 101h-1l1 1h1zm2-2h-1l1 1h1zm2-2h-1l1 1h1zm-4 0h-1l1 1h1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m67 113 1 3 3 1 2-1 1-3v-5h-7z",
    className: "Portugal_svg__H"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73 113-1 1 1 1zm-4 0-1 1 1 1zm2-2-1 1 1 1zm2-2-1 1 1 1zm-4 0-1 1 1 1z",
    className: "Portugal_svg__G"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 101 1 3 3 1 2-1 1-3v-6h-7z",
    className: "Portugal_svg__H"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 101h-1l1 1zm-4 0h-1l1 1zm2-2h-1l1 1zm2-2h-1l1 1z",
    className: "Portugal_svg__G"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6eb16",
    d: "M59 97h-1l1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 97h-1l1 1z",
    className: "Portugal_svg__G"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Portugal_svg__E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 77v-3h-7l-1 3zm1 1-1-1h-8v1zm-1-4 1-1h-9v1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 74h1l-1-1h-7l-1 1zm-5-6v2h2l1-1v-1h-1v1-1h-1v1-1zm2 2h-1l-1 3h2zm1 1v2h2v-2zm0-1v1h2v-1zm-5 0v1h2v-1zm0 3h2v-2h-2z"
  })), /*#__PURE__*/React.createElement("use", {
    className: "Portugal_svg__F",
    href: "#Portugal_svg__F"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Portugal_svg__E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 74s-2 1-2 3h4c0-2-2-3-2-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 75-1 2h3zm27 2-1-3h-7v3zm0 1v-1h-9l1 1zm0-4v-1h-9l1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 74h1l-1-1h-7v1zm-5-6v1l1 1h2v-2h-1v1-1h-1l1 1h-1v-1zm3 2h-2v3h2zm0 1v2h2v-2zm0-1v1h3v-1zm-5 0v1h2v-1zm0 3h2v-2h-2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70 71h1zm3 1q0-1.5 0 0m-5 0q0-1.5 0 0",
    className: "Portugal_svg__F"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Portugal_svg__E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 74s-2 1-2 3h4c0-2-2-3-2-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71 75-2 2h3zm-19 25v-3h-7l-1 3zm1 1v-1h-9v1zm-1-5h1l-1-1h-8v1zm0 1 1-1h-8l-1 1zm-5-6v1h3v-1zm2 1h-1l-1 3h2zm1 2v1h2v-1zm0-1v1h2v-1zm-5 0v1h2v-1zm0 2h2v-1h-2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48 93v1h1v-1zm3 1v1zm-5 0v1z",
    className: "Portugal_svg__F"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Portugal_svg__E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 97s-2 0-2 3h4c0-3-2-3-2-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 98-1 2h3c0-2-2-2-2-2m11 21-2-2-5 6 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 120v-1h-1l-5 6v1zm-3-3v-1h-1l-5 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 117-6 5v1h1zm-8 0h1l2-1-1-1v1l-1-1v2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 116-2 1 3 3 1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 117 2 1 1-2-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 116 1 1 2-2-1-1v1h-1v1-1zm-3 4h1l1-1v-1h-1v1-1l-1 1h1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51 122 1-2-1-1-1 1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52 118h1l-1-1zm2-2 1 1v-1zm-3 4s-1 0 0 0",
    className: "Portugal_svg__F"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Portugal_svg__E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 120s-1 2 1 3l3-2c-2-2-4-1-4-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 121 1 2 1-2zm34-44v-3h8v3zm0 1h-1l1-1h8v1zm0-4v-1h8v1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 74v-1h8v1zm5-6v2h-2l-1-1v-1h1v1-1h1v1-1zm-2 2h2v3h-2zm-1 1v2h-2v-2zm1-1v1h-3v-1zm5 0v1h-3v-1zm-1 3h-2l1-2h1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93 71q0-1.5 0 0m-3 1q0-1.5 0 0m6 0h-1z",
    className: "Portugal_svg__F"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Portugal_svg__E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93 74s2 1 2 3h-4c0-2 2-3 2-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93 75 1 2h-2zm-4 25v-3h8v3zm0 1-1-1h9v1zm0-5h-1l1-1h8v1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 97v-1h8v1c0 1 0 0 0 0zm5-6v1h-3v-1zm-2 1h2v3h-2zm-1 2v1h-2v-1zm1-1v1h-3v-1h2Zm5 0v1h-3v-1zm-1 2h-2l1-1h1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93 93v1zm-3 1v1zm6 0v1h-1v-1z",
    className: "Portugal_svg__F"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Portugal_svg__E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93 97s2 0 2 3h-4c0-3 2-3 2-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93 98 1 2h-2zm-11 21 2-2 6 6-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 120v-1h1l6 6v1h-1zm4-3v-1l6 6h-1l-6-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 117h1l5 5v1zm8 0h-1l-2-1 1-1v1h1v-1 2l1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90 116 1 1-2 3-2-2zm-2 1-1 1-2-2 2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89 116-1 1-2-2 1-1v1h1v1l1-1zm4 4h-1l-2-1v-1h1v1l1-1v1h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90 122-1-2 1-1 2 1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90 118h-1v-1zm-3-2v1h-1zm4 4h-1z",
    className: "Portugal_svg__F"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Portugal_svg__E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87 120s1 2-1 3l-3-2c2-2 4-1 4-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 121v2l-2-2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Portugal_svg__B)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffd276",
    d: "M173 2h294v196H173z"
  }))));
};
export default SvgPortugal;